import { api } from "../../lib/api";
import { AssetTypePropertyForFiltering, StringFilterType } from "../../swagger/caasService-v1";
export const getProjectAssetTrendsDetails = async (projectId, startDate, assetId, frequency) => {
    const projectAssetTrendsDetailsFilters = {
        filters: assetId
            ? [
                {
                    propertyName: AssetTypePropertyForFiltering.ASSET_ID,
                    type: StringFilterType.STRING_EQUALS,
                    values: [assetId]
                }
            ]
            : [
                {
                    propertyName: AssetTypePropertyForFiltering.ASSET_ID,
                    type: StringFilterType.STRING_EQUALS
                }
            ]
    };
    const projectAssetTrendsDetailsRequest = {
        ...projectAssetTrendsDetailsFilters,
        responseAttributes: ["assetId", "projectName", "projectId", "power", "soc", "timestamp"]
    };
    const { data } = await api.post(`/projects/${projectId}/assets/trends?startDate=${startDate}${frequency !== undefined ? `&frequency=${frequency}` : ""}`, projectAssetTrendsDetailsRequest);
    return {
        assetTrendsDetails: data.assetTrendsDetails,
        offset: data.offset,
        projectId: data.projectId,
        projectName: data.projectName,
        timezone: data.timezone
    };
};
